// copy of apps/keystone/src/schema/Permission/services/getUserActiveRoles.ts
import { Role, User } from 't2-graphql-types';
import { getUserActiveMemberships } from './getUserActiveMemberships';

export const getUserActiveRoles = (user: User | undefined): Role[] =>
  getUserActiveMemberships(user)
    .map((membership) => membership.role)
    .filter((role): role is Role => !!role) || [];
